module.exports = __webpack_public_path__ + "img/employmentType.4bf3d101.svg";